// const USER_OPTS = { cacheOnly : true, returnPromise : false }
import DataViewerModel from "../../DataViewerModel.js";
/**
 * A Card has a bunch of options that can be passed through. If it has 
 * a content, converter that. If no converter is specified, we'll assume the
 * content is a setting model to convert
 */
export default function convert(old, opts) {
  const {
    settingsRoot,
    converters,
    usedSettingsPath
  } = opts;
  const nSettings = {
    ...old
  };
  const {
    content
  } = nSettings;
  if (content == null || content?.settings) {
    return old;
  }
  const {
    type,
    id
  } = content;

  // const nSettingsRoot = `${settingsRoot}/dashboard`
  const nSettingsRoot = settingsRoot;
  const settingsPath = `${settingsRoot}/dashboard/${type}.${id}`;
  // const settingsPath = `${settingsRoot}/${type}.${id}`
  const nOpts = {
    ...opts,
    settingsRoot: nSettingsRoot,
    settingsPath,
    type: content.type
  };
  usedSettingsPath.add(settingsPath);
  if (converters.get(type)) {
    return {
      ...old,
      content: converters.create(type)(content, nOpts)
    };
  }
  // eslint-disable-next-line no-console
  console.log('Unknown Card Type:', type);
  return {
    ...old,
    content: DataViewerModel.create(type)
  };
}
convert.TYPE = 'uiDashboardCard';